import HeaderComponent from "../subComponent/HeaderComponent";
import React from "react";
import { Container, Typography, Link, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        '@media (max-width: 600px)': {
            '& .MuiTypography-h4': {
                fontSize: '1.5em', // Change h4 to h5 equivalent
            },
            '& .MuiTypography-h5': {
                fontSize: '1.25em', // Change h5 to h6 equivalent
            },
            '& .MuiTypography-h6': {
                fontSize: '1em', // Change h6 to p equivalent
                fontWeight: 'bold', // Make it bold
            },
            '& .MuiTypography-body1': {
                fontSize: '0.75em', // Change body1 to p with 0.75px
            },
            '& li': {
                fontSize: '0.9em',
            },
        },
    },
});

const TermsNC = () => {
    const classes = useStyles();

    return (
        <Box>
            <HeaderComponent />
            <Container>
                <Box p={3} className={classes.root}>
                    <Typography variant="h4" gutterBottom>
                        Terms and Conditions
                    </Typography>

                    <Typography variant="body1" gutterBottom>
                        Our Terms and Conditions was last updated on
                        <strong> 10th October 2024</strong>
                    </Typography>

                    <Typography variant="body1">
                        Welcome to <strong>INV TECHNOLOGIES</strong> ("we", "us", or "our"). These Terms and Conditions ("Terms") govern your use of our payments platform, accessible at{" "}
                        <Link href="https://payments.invtechnologies.in" target="_blank" rel="noopener noreferrer">
                            https://payments.invtechnologies.in
                        </Link>, and any services offered through our platform (collectively, the "Service").
                    </Typography>
                    <Box p={0.5} />

                    <Typography variant="body1">
                        By accessing or using the Service, you agree to comply with and be bound by these Terms. If you do not agree to these Terms, please refrain from using our Service.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Interpretation and Definitions
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Interpretation
                    </Typography>

                    <Typography variant="body1">
                        The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h6" gutterBottom>
                        Definitions
                    </Typography>

                    <Typography variant="body1" >
                        For the purposes of these Terms and Conditions:
                    </Typography>

                    <ul>
                        <li>
                            <Typography variant="body1">
                                <strong>"Company"</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to <strong>INV TECHNOLOGIES</strong>.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Service"</strong> refers to the Website which provides the payment links for transactions related to our offered services.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Website"</strong> refers to the online payment platform accessible at{" "}
                                <Link href="https://payments.invtechnologies.in" target="_blank" rel="noopener noreferrer">
                                    https://payments.invtechnologies.in
                                </Link>.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Payment Link"</strong> refers to the unique URL provided by the Company, allowing Users to make payments for our services.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Terms and Conditions"</strong> (also referred as <strong>"Terms"</strong> ) mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service. This Terms and Conditions Agreement was generated by Terms Feed Mobile App Terms and Conditions Generator..
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"You"</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                            </Typography>
                        </li>
                    </ul>

                    <Typography variant="h5" gutterBottom>
                        Acknowledgment
                    </Typography>

                    <Typography variant="body1" >
                        These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.
                    </Typography>
                    <Box p={0.5} />

                    <Typography variant="body1" >
                        Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms apply to all visitors, users, and others who access or use the Service.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        You represent that you are over the age of 18. The Company does not permit those under 18 to use the Service.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal information when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read Our Privacy Policy carefully before using Our Service.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Copyright Policy
                    </Typography>

                    <Typography variant="body1" >
                        All content on this Website, including but not limited to text, graphics, logos, and software, is the property of the Company or its licensors and is protected by copyright laws. Unauthorized use, reproduction, or distribution of this content is prohibited.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        You may not copy, reproduce, modify, distribute, or publicly display any part of the Website without prior written consent from the Company.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        DMCA Notice and DMCA Procedure for Copyright Infringement Claims
                    </Typography>

                    <Typography variant="body1" >
                        You may submit a notification pursuant to the Digital Millennium Copyright Act (DMCA) by providing our Copyright Agent with the following information in writing (see 17 U.S.C 512(c)(3) for further detail):
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright's interest.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                A description of the copyrighted work that You claim has been infringed, including the URL (i.e., web page address) of the location where the copyrighted work exists or a copy of the copyrighted work.
                            </Typography>
                        </li><li>
                            <Typography variant="body1">
                                Identification of the URL or other specific location on the Service where the material that You claim is infringing is located.
                            </Typography>
                        </li><li>
                            <Typography variant="body1">
                                Your address, telephone number, and email address.
                            </Typography>
                        </li><li>
                            <Typography variant="body1">
                                A statement by You that You have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law.
                            </Typography>
                        </li><li>
                            <Typography variant="body1">
                                A statement by You, made under penalty of perjury, that the above information in Your notice is accurate and that You are the copyright owner or authorized to act on the copyright owner's behalf.
                            </Typography>
                        </li>
                    </ul>
                    <Box p={0.5} />
                    <Typography variant="body1">
                        You can contact our copyright agent via email <u>payments.invtechnologies@gmail.com</u> receipt of a notification, the Company will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged content from the Service.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Intellectual Property
                    </Typography>

                    <Typography variant="body1" >
                        The Service and its original content (excluding Content provided by You or other users), features and functionality are and will remain the exclusive property of the Company and its licensors.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        The Service is protected by copyright, trademark, and other laws of both the Country and foreign countries.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of the Company.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Payment Links
                    </Typography>

                    <Typography variant="body1" >
                        The payment links provided by the Company are solely for use in completing authorized transactions for services rendered. Users are responsible for ensuring the correct amount is paid using the provided link. The Company is not liable for any misuse or unauthorized use of payment links.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Payment completion is subject to the successful processing by the payment provider. Users will receive confirmation of payment, and it is advised to retain this for future reference.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Limitation of Liability
                    </Typography>

                    <Typography variant="body1" >
                        Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service or 100 USD if You haven't purchased anything through the Service.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other information, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party's liability will be limited to the greatest extent permitted by law.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Governing Law
                    </Typography>

                    <Typography variant="body1" >
                        The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Service may also be subject to other local, state, national, or international laws.

                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Disputes Resolution
                    </Typography>

                    <Typography variant="body1" >
                        If You have any concern or dispute about the Service, You agree to first try to resolve the dispute informally by contacting the Company.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Severability and Waiver
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        Severability
                    </Typography>
                    <Typography variant="body1" >
                        If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="h6" gutterBottom>
                        Waiver
                    </Typography>
                    <Typography variant="body1" >
                        Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Changes to These Terms and Conditions
                    </Typography>

                    <Typography variant="body1" >
                        We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material. What constitutes a material change will be determined at Our sole discretion.
                    </Typography>
                    <Box p={0.5} />
                    <Typography variant="body1" >
                        By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Contact Us
                    </Typography>

                    <Typography variant="body1">
                        If you have any questions about this Terms and Conditions, You can contact us:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                By sending us an email to{" "}
                                <Link href="mailto:payments.invtechnologies@gmail.com">
                                    payments.invtechnologies@gmail.com
                                </Link>.
                            </Typography>
                        </li>
                    </ul>
                </Box>
            </Container>

        </Box>
    )
}
export default TermsNC;